import { render, staticRenderFns } from "./ResourceUpload.vue?vue&type=template&id=6bc217a4&scoped=true&"
import script from "./ResourceUpload.vue?vue&type=script&lang=js&"
export * from "./ResourceUpload.vue?vue&type=script&lang=js&"
import style0 from "./ResourceUpload.vue?vue&type=style&index=0&id=6bc217a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc217a4",
  null
  
)

export default component.exports